import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../const";
import _ from 'lodash';
import { Service } from "../../../../modules/service/service"
import { unAuthorized } from '../../../../modules/auth/Auth.ducks'


export const GET_EVENT_PENDING = "GET_EVENT_PENDING";
export const GET_EVENT_REJECTED = "GET_EVENT_REJECTED";
export const GET_EVENT_FULFILLED = "GET_EVENT_FULFILLED";


export const GET_ALL_EVENT_PENDING = "GET_ALL_EVENT_PENDING";
export const GET_ALL_EVENT_REJECTED = "GET_ALL_EVENT_REJECTED";
export const GET_ALL_EVENT_FULFILLED = "GET_ALL_EVENT_FULFILLED";

export const ADD_EVENT_PENDING = "ADD_EVENT_PENDING";
export const ADD_EVENT_REJECTED = "ADD_EVENT_REJECTED";
export const ADD_EVENT_FULFILLED = "ADD_EVENT_FULFILLED";

export const EDIT_EVENT_PENDING = "EDIT_EVENT_PENDING";
export const EDIT_EVENT_REJECTED = "EDIT_EVENT_REJECTED";
export const EDIT_EVENT_FULFILLED = "EDIT_EVENT_FULFILLED";

export const DELETE_EVENT_PENDING = "DELETE_EVENT_PENDING";
export const DELETE_EVENT_REJECTED = "DELETE_EVENT_REJECTED";
export const DELETE_EVENT_FULFILLED = "DELETE_EVENT_FULFILLED";

export const CANCEL_EVENT_PENDING = "CANCEL_EVENT_PENDING";
export const CANCEL_EVENT_REJECTED = "CANCEL_EVENT_REJECTED";
export const CANCEL_EVENT_FULFILLED = "CANCEL_EVENT_FULFILLED";


const loading = (state = {}, { type }) => {
  switch (type) {
    // case GET_EVENT_PENDING:
    // case ADD_EVENT_PENDING:
    // case EDIT_EVENT_PENDING:
    // case DELETE_EVENT_PENDING:
    case GET_ALL_EVENT_PENDING:

      return true;
    case GET_EVENT_REJECTED:
    case GET_EVENT_FULFILLED:
    case ADD_EVENT_REJECTED:
    case ADD_EVENT_FULFILLED:
    case GET_ALL_EVENT_REJECTED:
    case GET_ALL_EVENT_FULFILLED:
    case DELETE_EVENT_REJECTED:
    case DELETE_EVENT_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_EVENT_FULFILLED:
    case GET_EVENT_PENDING:
    case ADD_EVENT_FULFILLED:
    case ADD_EVENT_PENDING:
    case EDIT_EVENT_FULFILLED:
    case EDIT_EVENT_PENDING:
    case GET_ALL_EVENT_PENDING:
    case GET_ALL_EVENT_FULFILLED:
    case DELETE_EVENT_PENDING:
    case DELETE_EVENT_FULFILLED:

      return null;
    case GET_EVENT_REJECTED:
    case ADD_EVENT_REJECTED:
    case EDIT_EVENT_REJECTED:
    case GET_ALL_EVENT_REJECTED:
    case DELETE_EVENT_REJECTED:

      return payload;
    default:
      return null;
  }
};


const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_ALL_EVENT_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;
    default:
      return state;
  }
};
const dataEventById = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_EVENT_FULFILLED:

      return _.isEmpty(payload.data) ? null : payload.data;

    default:
      return state;
  }
};


export default combineReducers({ loading, error, data, dataEventById });

export const getEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/creche/events/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_EVENT_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_EVENT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const getAllEvent = (tok) => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_EVENT_PENDING })
    const response = Service.get(`${API}api/creche/events?offset=1&path-size=20`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_ALL_EVENT_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_ALL_EVENT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const AddEvent = (tok, data) => {
  return (dispatch) => {
    dispatch({ type: ADD_EVENT_PENDING })
    const response = Service.post(`${API}api/creche/events`, data, {
      headers: {
        Authorization: `Bearer ${tok}`, 'Content-Type': 'application/json'
      }
    })
    response.then((res) => {
      dispatch({ type: ADD_EVENT_FULFILLED, payload: res })
      dispatch(getAllEvent(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: ADD_EVENT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}






export const EditEvent = (tok, data, idEvent) => {
  return (dispatch) => {
    dispatch({ type: EDIT_EVENT_PENDING })
    const response = Service.put(`${API}api/creche/events/${idEvent}`, data, {
      headers: {
        Authorization: `Bearer ${tok}`, 'Content-Type': 'application/json'
      }
    })
    response.then((res) => {
      dispatch({ type: EDIT_EVENT_FULFILLED, payload: res })
      dispatch(getAllEvent(tok))
    })
    response.catch(err => {
      dispatch({ type: EDIT_EVENT_REJECTED, payload: err })
      let message = !_.isEmpty(err.response) ? err.response.data.message : err.response;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const cancelEvent = (tok, idEvent,data) => {
  return (dispatch) => {
    dispatch({ type: CANCEL_EVENT_PENDING })
    const response = Service.put(`${API}api/creche/events/${idEvent}/annuler`, {}, {
      headers: {
        Authorization: `Bearer ${tok}`, 'Content-Type': 'application/json'
      }
    })
    response.then((res) => {
      dispatch({ type: CANCEL_EVENT_FULFILLED, payload: res })
      dispatch({ type: "OPEN_SNACKBAR_SUCCESS" })
      dispatch(getAllEvent(tok))
    })
    response.catch(err => {
      dispatch({ type: CANCEL_EVENT_REJECTED, payload: err })
      let message = !_.isEmpty(err.response) ? err.response.data.message : err.response;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}



export const DeleteEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/creche/events/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_EVENT_FULFILLED, payload: res })
      dispatch(getAllEvent(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_EVENT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}


